import Vue from 'vue'
import Router from 'vue-router'
import home from "./views/home";
import hashdetails from "./views/hash-details";
import tokendetails from "./views/token-details";
import contract from "./views/contract-address";
import user from "./views/user-address";

Vue.use(Router)

export default new Router({
  
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      name: 'index',
      component: () => import('./views/index.vue'),
      children:[
        {
          path:'',
          name:'home',
          component: home
        },
        {
          path:'hash-details',
          name:'hash-details',
          component: hashdetails
        },
        {
          path:'contract-address',
          name:'contract-address',
          component: contract
        },
        // {
        //   path:'token-details',
        //   name:'token-details',
        //   component: tokendetails
        // },
        {
          path:'user-address',
          name:'user-address',
          component: user
        },
      ]
    },
    {
      path: '/head',
      name: 'head',
      component: () => import('./components/main-head.vue'),
    },
    {
      path: '/footer',
      name: 'footer',
      component: () => import('./components/main-footer.vue'),
    },
    {
      path:'/evidence-details',
      name:'evidence-details',
      component: () => import('./views/token-details'),
    },
  ]
})
